import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { Panel, Col, Row, Button, ButtonGroup } from 'react-bootstrap';
import Navigation from '../components/Navigation';
import AuditLogFilters from '../components/AuditLogFilters';
import AuditLogsTable from '../components/AuditLogsTable';
import AuditLogDetailModal from '../components/AuditLogDetailModal';
import PaginationPanel from '../components/PaginationPanel';
import DismissableAlert from '../components/DismissableAlert';
import config from '../config';
import axios from 'axios';
import Moment from 'moment';
import { Link } from 'react-router-dom';
import './OrganisationAuditLogs.css';

axios.defaults.withCredentials = true;

class PlayerAuditLogs extends Component {
    constructor(props) {
        super(props);

        // Default to last 30 days for player logs (longer range to see check-ins)
        const defaultStartDate = Moment().subtract(30, 'days').toISOString();
        const defaultEndDate = Moment().toISOString();

        this.state = {
            uuid: props.match.params.uuid,
            playerUUID: props.match.params.playerUUID,
            player: null,
            auditLogs: [],
            loading: false,
            exporting: false,
            nextToken: null,
            hasMore: false,
            excludeRead: true, // Exclude read actions by default
            activeQuickFilter: null,
            filters: {
                action: '',
                ipAddress: '',
                startDate: defaultStartDate,
                endDate: defaultEndDate
            },
            selectedLog: null,
            showDetailModal: false,
            error: {
                hidden: true,
                title: '',
                message: '',
                style: 'danger'
            }
        };
    }

    componentDidMount() {
        this.loadPlayer();
        this.loadAuditLogs();
    }

    loadPlayer = () => {
        const self = this;
        axios
            .get(`${config.baseURL}/players/${this.state.playerUUID}`)
            .then(function(response) {
                self.setState({ player: response.data.player });
            })
            .catch(function(error) {
                console.error('Failed to load player:', error);
            });
    };

    loadAuditLogs = (loadMore = false) => {
        const self = this;
        this.setState({ loading: true });

        const params = {
            limit: 50
        };

        // Add filters
        if (this.state.filters.action) params.action = this.state.filters.action;
        if (this.state.filters.ipAddress) params.ipAddress = this.state.filters.ipAddress;
        if (this.state.filters.startDate) params.startDate = this.state.filters.startDate;
        if (this.state.filters.endDate) params.endDate = this.state.filters.endDate;

        // Exclude read actions by default (unless user specifically filters for them)
        if (this.state.excludeRead && !this.state.filters.action) {
            params.excludeActions = 'read';
        }

        // Add pagination token for load more
        if (loadMore && this.state.nextToken) {
            params.nextToken = this.state.nextToken;
        }

        console.log('Loading player audit logs with params:', params);

        axios
            .get(`${config.baseURL}/organisations/${this.state.uuid}/players/${this.state.playerUUID}/audit-logs`, { params })
            .then(function(response) {
                console.log('Player audit logs response:', response.data);
                const newLogs = response.data.auditLogs || [];

                self.setState({
                    auditLogs: loadMore ? [...self.state.auditLogs, ...newLogs] : newLogs,
                    nextToken: response.data.nextToken,
                    hasMore: response.data.hasMore,
                    loading: false,
                    error: { hidden: true, title: '', message: '', style: 'danger' }
                });
            })
            .catch(function(error) {
                console.error('Player audit logs error:', error);
                const errorMessage = error.response && error.response.data && error.response.data.message
                    ? error.response.data.message
                    : error.message || 'Failed to load audit logs';
                self.setState({
                    loading: false,
                    error: {
                        hidden: false,
                        title: 'Error:',
                        message: errorMessage,
                        style: 'danger'
                    }
                });
            });
    };

    handleFilterChange = (newFilters) => {
        this.setState(
            {
                filters: {
                    ...this.state.filters,
                    ...newFilters
                },
                nextToken: null,
                auditLogs: []
            },
            () => {
                this.loadAuditLogs(false);
            }
        );
    };

    handleClearFilters = () => {
        const defaultStartDate = Moment().subtract(30, 'days').toISOString();
        const defaultEndDate = Moment().toISOString();

        this.setState({
            activeQuickFilter: null,
            filters: {
                action: '',
                ipAddress: '',
                startDate: defaultStartDate,
                endDate: defaultEndDate
            },
            nextToken: null,
            auditLogs: []
        }, () => {
            this.loadAuditLogs(false);
        });
    };

    handleQuickFilter = (filterType) => {
        const { t } = this.props;
        let newFilters = { ...this.state.filters };

        switch (filterType) {
            case 'today':
                newFilters.startDate = Moment().startOf('day').toISOString();
                newFilters.endDate = Moment().endOf('day').toISOString();
                newFilters.action = '';
                break;
            case 'last7days':
                newFilters.startDate = Moment().subtract(7, 'days').toISOString();
                newFilters.endDate = Moment().toISOString();
                newFilters.action = '';
                break;
            case 'last30days':
                newFilters.startDate = Moment().subtract(30, 'days').toISOString();
                newFilters.endDate = Moment().toISOString();
                newFilters.action = '';
                break;
            case 'checkins':
                newFilters.action = 'player_checkin';
                newFilters.startDate = Moment().subtract(30, 'days').toISOString();
                break;
            case 'updates':
                newFilters.action = 'update';
                newFilters.startDate = Moment().subtract(30, 'days').toISOString();
                break;
            default:
                break;
        }

        this.setState({ activeQuickFilter: filterType }, () => {
            this.handleFilterChange(newFilters);
        });
    };

    handleLoadMore = () => {
        this.loadAuditLogs(true);
    };

    handleViewDetails = (log) => {
        this.setState({
            selectedLog: log,
            showDetailModal: true
        });
    };

    handleCloseDetailModal = () => {
        this.setState({
            showDetailModal: false,
            selectedLog: null
        });
    };

    render() {
        const { t } = this.props;
        const playerName = this.state.player ? this.state.player.name : 'Player';
        document.title = `MySign Digital Screen Solutions | ${t('AuditLogs.playerTitle')} - ${playerName}`;

        return (
            <div className="OrganisationAuditLogs">
                <div id="wrapper">
                    <Navigation props={this.props} />
                    <div id="content-wrapper">
                        <Row>
                            <Col lg={12}>
                                <h1>{t('AuditLogs.playerTitle')}: {playerName}</h1>

                                <ol className="breadcrumb">
                                    <li>
                                        <i className="fa fa-tachometer-alt" />{' '}
                                        <Link to={`/organisations/${this.state.uuid}`}>
                                            {t('Dashboard.title')}
                                        </Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-tv" />{' '}
                                        <Link to={`/organisations/${this.state.uuid}/players`}>
                                            {t('SideNavigation.players')}
                                        </Link>
                                    </li>
                                    <li>
                                        <i className="fa fa-tv" />{' '}
                                        <Link to={`/organisations/${this.state.uuid}/players/${this.state.playerUUID}/edit`}>
                                            {playerName}
                                        </Link>
                                    </li>
                                    <li className="active">
                                        <i className="fa fa-clipboard-list" /> {t('AuditLogs.title')}
                                    </li>
                                </ol>

                                <DismissableAlert
                                    hidden={this.state.error.hidden}
                                    title={this.state.error.title}
                                    message={this.state.error.message}
                                    style={this.state.error.style}
                                />

                                <div className="quick-filters">
                                    <div style={{ marginBottom: '10px' }}>
                                        <p style={{ margin: 0 }}><strong>{t('AuditLogs.quickFilters')}:</strong></p>
                                    </div>
                                    <ButtonGroup>
                                        <Button
                                            bsSize="small"
                                            bsStyle={this.state.activeQuickFilter === 'checkins' ? 'primary' : 'default'}
                                            onClick={() => this.handleQuickFilter('checkins')}
                                            active={this.state.activeQuickFilter === 'checkins'}
                                        >
                                            <i className="fa fa-clock" /> {t('AuditLogs.checkins')}
                                        </Button>
                                        <Button
                                            bsSize="small"
                                            bsStyle={this.state.activeQuickFilter === 'updates' ? 'info' : 'default'}
                                            onClick={() => this.handleQuickFilter('updates')}
                                            active={this.state.activeQuickFilter === 'updates'}
                                        >
                                            <i className="fa fa-edit" /> Updates
                                        </Button>
                                    </ButtonGroup>
                                    <div style={{ marginTop: '10px' }}>
                                        <ButtonGroup>
                                            <Button
                                                bsSize="small"
                                                active={this.state.activeQuickFilter === 'today'}
                                                onClick={() => this.handleQuickFilter('today')}
                                            >
                                                {t('AuditLogs.today')}
                                            </Button>
                                            <Button
                                                bsSize="small"
                                                active={this.state.activeQuickFilter === 'last7days'}
                                                onClick={() => this.handleQuickFilter('last7days')}
                                            >
                                                {t('AuditLogs.last7Days')}
                                            </Button>
                                            <Button
                                                bsSize="small"
                                                active={this.state.activeQuickFilter === 'last30days'}
                                                onClick={() => this.handleQuickFilter('last30days')}
                                            >
                                                {t('AuditLogs.last30Days')}
                                            </Button>
                                        </ButtonGroup>
                                    </div>
                                </div>

                                <AuditLogFilters
                                    filters={this.state.filters}
                                    onFilterChange={this.handleFilterChange}
                                />

                                <PaginationPanel
                                    heading={
                                        <span>
                                            <i className="fa fa-clipboard-list" /> {t('AuditLogs.title')}
                                            {this.state.loading && (
                                                <span className="loading-indicator"> ({t('AuditLogs.loading')})</span>
                                            )}
                                        </span>
                                    }
                                    pagination={
                                        this.state.hasMore ? (
                                            <Button
                                                onClick={this.handleLoadMore}
                                                disabled={this.state.loading}
                                                bsStyle="primary"
                                            >
                                                {this.state.loading ? (
                                                    <span><i className="fa fa-spinner fa-spin" /> Loading...</span>
                                                ) : (
                                                    <span><i className="fa fa-angle-down" /> {t('AuditLogs.loadMore')}</span>
                                                )}
                                            </Button>
                                        ) : null
                                    }
                                >
                                    <AuditLogsTable
                                        logs={this.state.auditLogs}
                                        onViewDetails={this.handleViewDetails}
                                    />
                                </PaginationPanel>
                            </Col>
                        </Row>
                    </div>
                </div>

                <AuditLogDetailModal
                    show={this.state.showDetailModal}
                    onHide={this.handleCloseDetailModal}
                    log={this.state.selectedLog}
                />
            </div>
        );
    }
}

export default translate('translations')(PlayerAuditLogs);
